module.exports = __webpack_public_path__ + "static/media/aniket-agarwal.7016737d.jpg";